export const version = "7.1.0";
export const major = Number("7");
export const minor = Number("1");
export const patch = Number("0");
export const prerelease = undefined;
export default version;